<template>
  <div class="text-xs-right">
    <v-menu
      class="elevation-3"
      v-model="menu"
      @input="onChangeMenu"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
      elevation-1
    >
      <template v-slot:activator="{ on }">
        <span style="position: relative">
          <v-btn v-on="on" icon outline color="primary"><em class="fas fa-bell" /></v-btn>
          <div>
            <v-chip
              v-if="unread_total"
              style="position: absolute; right: -19px; top: -19px"
              dark
              color="red"
              small
              >{{ unread_total }}</v-chip
            >
          </div>
        </span>
      </template>

      <v-card
        color="rgb(245 245 245)"
        elevation-1
        style="white-space: pre-line; max-height: 250px; overflow: auto"
      >
        <div v-for="(log, k) in worklog" :key="k">
          <div class="pa-3 ml-2">
            <div>
              <div class="text-xs-right caption">
                {{ log.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}
              </div>
              <div style="font-size: 14px">
                {{ log.description.trim() }}
              </div>
            </div>
          </div>
          <v-divider></v-divider>
        </div>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  data: () => ({
    fav: true,
    menu: false,
    message: false,
    hints: true,
    worklog: [],
    read_length: 0,
    new_length: 0,
    timer: ''
  }),
  computed: {
    unread_total() {
      return this.new_length - this.read_length
    },
    ...mapGetters(['selectedBot'])
  },
  async mounted() {
    await this.getWorklog()
    this.timer = setInterval(async () => {
      await this.getWorklog()
    }, 120000)
  },
  destroyed() {
    clearInterval(this.timer)
  },

  methods: {
    onChangeMenu(val) {
      if (val) {
        this.read_length = this.new_length
      }
    },
    getWorklog() {
      return new Promise((resolve) => {
        api.ticket2Commonticketworklog({ pageid: this.selectedBot.pageid }, (err, response) => {
          this.worklog = response.data
          this.new_length = this.worklog.length
          resolve()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toa/management/notifyMenu.vue